import * as classnames from "classnames";
import { isEqual } from "lodash";
import * as React from "react";

import {
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  PageTitle,
  Loading,
} from "../../../shared/components";
import { ApplicantInitialModel } from "../../../shared/models";

/**
 * Prop interface
 */
export interface SigninProps {
  isOpen: boolean;
  loading: boolean;
  exam: ApplicantInitialModel;

  verifyEmail: (payload: {}) => void;
}

/**
 * State interface
 */
export interface SigninState {
  formValid: boolean;
  formValues: {};
}

/**
 * Page component
 */
class Signin extends React.Component<SigninProps, SigninState> {
  constructor(props: SigninProps) {
    super(props);

    this.state = {
      formValid: false,
      formValues: {},
    };
  }

  public shouldComponentUpdate(nextProps: SigninProps, nextState: SigninState) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  }

  public render() {
    const rootStyle = classnames("code-applicant-signin");

    const { isOpen, exam, loading } = this.props;

    return (
      <Modal
        className={rootStyle}
        isOpen={isOpen}
        title="メールアドレスの確認"
        hasCancelButton={false}
        okButtonLabel="メールアドレスを確認する"
        disableOk={!this.state.formValid || loading}
        onClickOk={this.onVerifyEmail}
      >
        <Loading isOpen={loading} />
        <div className="code-applicant-signin__exam">
          <p>{exam.organizationName}</p>
          <PageTitle>{exam.examName}</PageTitle>
        </div>
        <p className="code-applicant-signin__text">
          試験を始める前にメールアドレスの確認を行います。
        </p>
        <Form
          className="code-applicant-signin__form"
          validation={{
            email: ["string", "required", "strictEmail"],
          }}
          initialValues={{
            email: "",
          }}
          onFormChange={this.onFormChange}
          submitting={loading}
        >
          <FormGroup className="code-applicant-signin__email">
            <Label title="メールアドレス" />
            <Input name="email" autocomplete="email" />
          </FormGroup>
        </Form>
      </Modal>
    );
  }

  private onVerifyEmail = () => {
    this.props.verifyEmail({
      ...this.state.formValues,
      token: this.props.exam.urlToken,
    });
  };

  private onFormChange = (formValid: boolean, formValues: {}) => {
    this.setState({ formValid, formValues });
  };
}

export default Signin;
